import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SearchableMenu, SearchableMenuMultiSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { useSearchContext } from '../SearchProvider';
export function AddFilterButton(props) {
    const { filterItems } = props;
    const { toggleFilter, activeFilters } = useSearchContext();
    return (<SearchableMenu items={filterItems} keys={['name']} placeholder={t({
            message: 'Find filter...',
            comment: 'Search filters: Add filter menu search placeholder',
        })} renderTarget={<Button type="button" size="small" appearance="secondary">
          <Falcon icon="plus"/>
          <Trans comment="Search: Add filter menu button">Filters</Trans>
        </Button>}>
      <SearchableMenuMultiSelectList selected={activeFilters} onSelect={(item) => toggleFilter(item.id)} renderItem={({ name }) => name}/>
    </SearchableMenu>);
}
